import { z } from 'zod';

/** Grupo de atendentes (visibilidade de mesas). */
export const GroupSchema = z.object({
  id: z.number().int(),
  name: z.string(),
  active: z.boolean(),
  memberIds: z.array(z.number().int()),
  /**
   * Spec 061: o grupo é espelho de um grupo técnico do TiFlux? Então estes
   * usuários (os que vêm do TiFlux) entram e saem dele pelo TiFlux, a cada
   * sincronização, e o nome também vem de lá. Os outros (criados no ERP) se
   * incluem aqui e ficam. null = grupo do ERP: tudo se edita aqui.
   */
  tifluxManagedUserIds: z.array(z.number().int()).nullable(),
});
export type Group = z.infer<typeof GroupSchema>;

/** POST cria; PUT substitui os membros pela lista enviada. */
export const GroupBodySchema = z.object({
  name: z.string().min(1),
  active: z.boolean().optional(),
  userIds: z.array(z.number().int().positive()),
});
export type GroupBody = z.infer<typeof GroupBodySchema>;

/** PUT /desks/:id/groups — substitui os vínculos; vazio = mesa visível a todos. */
export const DeskGroupsPutBodySchema = z.object({
  groupIds: z.array(z.number().int().positive()),
});
export type DeskGroupsPutBody = z.infer<typeof DeskGroupsPutBodySchema>;
